function checkRemoveCard() {
    let tentativas = 0;
    let intervalo = setInterval(() => {

        if ($('.rnk-body-myaccount .vtex-account__cards-list article').length > 0) {
            removerCard();
            clearInterval(intervalo);
        } else {
            tentativas++
            if (tentativas > 50) {
                clearInterval(intervalo);
            }
        }

    }, 1000);
};

function removerCard() {
    let tentativas = 0;
    let mensagemCartaoRemovido = `
        <div class="alert alert-dark alert-remove-card alert-dismissible fade show" role="alert">
            Cartão removido com sucesso!
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    `

    if ($('.rnk-alert-remove-card').length == 0) {
        $('.rnk-body-myaccount .render-container').append('<div class="rnk-alert-remove-card"></div>');
    }

    let intervalo = setInterval(() => {
        if ($('.rnk-body-myaccount .vtex-modal__modal').length > 0) {
            clearInterval(intervalo);

            $('.rnk-body-myaccount .vtex-modal__modal span.mr4 + button.vtex-button').click(() => {
                $('.rnk-alert-remove-card').html(mensagemCartaoRemovido);

                $('.rnk-alert-remove-card .alert button.close').click(() => {
                    $('.rnk-alert-remove-card').html('');
                })

                setTimeout(() => {
                    $('.rnk-alert-remove-card').html('');
                }, 8000);

                checkRemoveCard();
            });

            $('.rnk-body-myaccount .vtex-modal__modal span.mr4').click(() => {
                checkRemoveCard();
            });

            $('.rnk-body-myaccount .vtex-modal__modal .vtex-modal__close-icon').click(() => {
                checkRemoveCard();
            });

        } else {
            tentativas++
            if (tentativas > 50) {
                clearInterval(intervalo);                
                checkRemoveCard();
            }
        }
    }, 500);
};

checkRemoveCard();

export default {};